import { PLACEMENT } from '@hookform/devtools/dist/position';
import dynamic from 'next/dynamic';
import { Control, FieldValues } from 'react-hook-form';

type DevToolsProps<T extends FieldValues> =
  | {
      control?: Control<T, object> | undefined;
      placement?: PLACEMENT | undefined;
    }
  | undefined;

// @ts-ignore
export const ReactHookFormDevTools = dynamic<DevToolsProps>(
  () => import('@hookform/devtools').then((e) => e.DevTool),
  { ssr: false },
);
